module.exports = "/assets/images/ico-zasuvka-3w.6ea5e094.png";